module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray-100 min-h-screen"
  }, [(_vm.isMovil) ? _c('div', {
    staticClass: "p-2"
  }, [_c("transition-group", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lista.length !== 0),
      expression: "lista.length !== 0"
    }, {
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    tag: "div",
    staticClass: "contenedor-transition-box",
    attrs: {
      "name": "slide-up",
      "infinite-scroll-disabled": "disabledScrollExecute",
      "infinite-scroll-distance": "2"
    }
  }, _vm._l((_vm.lista), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "mb-2",
      on: {
        "click": function($event) {
          item.showFull = !item.showFull
        }
      }
    }, [(index === 0 || item.fechaString !== _vm.lista[index - 1].fechaString) ? _c('div', {
      staticClass: "flex justify-center mb-2"
    }, [_c('span', {
      staticClass: "text-xxs rounded-full px-3 bg-primary text-white p-1 rounded leading-none"
    }, [_vm._v(_vm._s(_vm._f("formatDateDay")(item.fecha)))])]) : _vm._e(), _c('div', {
      staticClass: "p-5 bg-white rounded-lg shadow-xs relative"
    }, [_c('div', {
      staticClass: "absolute top-0 left-0 mt-1 ml-1"
    }, [_c('div', {
      staticClass: "text-gray-500 text-xs"
    }, [_vm._v(_vm._s(item.hora))])]), _c('div', {
      staticClass: "absolute top-0 right-0 mt-1 mr-1",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.irACirugia(item._id)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-edit text-gray-500"
    })]), _c('span', {
      staticClass: "text-sm font-bold"
    }, [_vm._v(_vm._s(item.descripcionTipoCirugia))]), _c('span', {
      staticClass: "text-sm"
    }, [_vm._v(" con ")]), _c('span', {
      staticClass: "text-sm font-bold"
    }, [_vm._v(_vm._s(item.nombreDoctor))]), _c('span', {
      staticClass: "text-sm"
    }, [_vm._v(" en ")]), _c('span', {
      staticClass: "text-sm font-bold"
    }, [_vm._v(_vm._s(item.descripcionClinica))]), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.showFull),
        expression: "item.showFull"
      }]
    }, [_c('div', {
      staticClass: "flex text-xs mt-4"
    }, [_c('div', {
      staticClass: "flex flex-col flex-1 items-center"
    }, [_c('i', {
      staticClass: "fas fa-user-cog text-gray-500"
    }), _c('span', {
      staticClass: "font-bold text-xxs"
    }, [_vm._v(_vm._s(item.nombreTecnico))])]), _c('div', {
      staticClass: "flex flex-col flex-1 items-center"
    }, [_c('i', {
      staticClass: "fas fa-user-nurse text-gray-500"
    }), _c('span', {
      staticClass: "font-bold text-xxs"
    }, [_vm._v(_vm._s(item.nombreEnfermera))])]), (item.montoCobrado > 0) ? _c('div', {
      staticClass: "flex flex-col flex-1 items-center"
    }, [_c('i', {
      staticClass: "fas fa-money-bill text-gray-500"
    }), _c('span', {
      staticClass: "font-bold text-xxs"
    }, [_vm._v("S/ " + _vm._s(_vm._f("twoDecimals")(item.montoCobrado)))])]) : _vm._e()]), (item.comentario) ? _c('div', {
      staticClass: "mt-3 text-xs text-left text-blue-600 bg-blue-200 border border-blue-400 flex items-center p-3 rounded-sm"
    }, [_vm._v(_vm._s(item.comentario))]) : _vm._e()])])])
  }), 0)], 1) : _c('div', [_c('div', {
    staticClass: "filtros flex mt-2 justify-center items-center"
  }, [_c('div', {
    staticClass: "flex flex-col flex-1"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('div', {
    key: "doctor",
    staticClass: "flex mb-2 flex p-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Doctor")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nombreDoctor),
      expression: "nombreDoctor"
    }],
    ref: "doctor",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "placeholder": "No se han ingresado datos"
    },
    domProps: {
      "value": (_vm.nombreDoctor)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.showPopoverDoctor = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.showPopoverDoctor = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        _vm.showPopoverDoctor = true
      }],
      "click": function($event) {
        _vm.showPopoverDoctor = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nombreDoctor = $event.target.value
      }
    }
  }), _vm._m(0), _c('span', {
    staticClass: "absolute right-0 top-0 pt-2 pr-3",
    on: {
      "click": function($event) {
        _vm.showPopoverDoctor = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-down text-gray-500"
  })]), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [(_vm.showPopoverDoctor) ? _c('u-popover', {
    on: {
      "close": function($event) {
        _vm.showPopoverDoctor = false
      }
    }
  }, [_c('doctor-seleccionar', {
    on: {
      "selected": _vm.seleccionarDoctor,
      "close": _vm.cerrarDoctor
    }
  })], 1) : _vm._e()], 1)], 1)])]), _c('div', {
    key: "clinica",
    staticClass: "flex mb-2 p-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Clínica")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descripcionClinica),
      expression: "descripcionClinica"
    }],
    ref: "clinica",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "placeholder": "No se han ingresado datos"
    },
    domProps: {
      "value": (_vm.descripcionClinica)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.showPopoverClinica = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.showPopoverClinica = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        _vm.showPopoverClinica = true
      }],
      "click": function($event) {
        _vm.showPopoverClinica = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descripcionClinica = $event.target.value
      }
    }
  }), _vm._m(1), _c('span', {
    staticClass: "absolute right-0 top-0 pt-2 pr-3",
    on: {
      "click": function($event) {
        _vm.showPopoverClinica = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-down text-gray-500"
  })]), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [(_vm.showPopoverClinica) ? _c('u-popover', {
    on: {
      "close": function($event) {
        _vm.showPopoverClinica = false
      }
    }
  }, [_c('clinica-seleccionar', {
    on: {
      "selected": _vm.seleccionarClinica,
      "close": _vm.cerrarClinica
    }
  })], 1) : _vm._e()], 1)], 1)])]), _c('div', {
    key: "tipo-cirugia",
    staticClass: "flex mb-2 p-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Tipo cirugía")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descripcionTipoCirugia),
      expression: "descripcionTipoCirugia"
    }],
    ref: "tipoCirugia",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "placeholder": "No se han ingresado datos"
    },
    domProps: {
      "value": (_vm.descripcionTipoCirugia)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.showPopoverTipoCirugia = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.showPopoverTipoCirugia = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        _vm.showPopoverTipoCirugia = true
      }],
      "click": function($event) {
        _vm.showPopoverTipoCirugia = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descripcionTipoCirugia = $event.target.value
      }
    }
  }), _vm._m(2), _c('span', {
    staticClass: "absolute right-0 top-0 pt-2 pr-3",
    on: {
      "click": function($event) {
        _vm.showPopoverTipoCirugia = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-down text-gray-500"
  })]), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [(_vm.showPopoverTipoCirugia) ? _c('u-popover', {
    on: {
      "close": function($event) {
        _vm.showPopoverTipoCirugia = false
      }
    }
  }, [_c('tipo-cirugia-seleccionar', {
    on: {
      "selected": _vm.seleccionarTipoCirugia,
      "close": _vm.cerrarTipoCirugia
    }
  })], 1) : _vm._e()], 1)], 1)])]), _c('div', {
    key: "tipo-cobro",
    staticClass: "flex mb-2 p-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Tipo cobro")]), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "flex flex-col flex-1 cursor-pointer justify-center items-center m-1 bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded py-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm transition duration-300 ease-in-out",
    class: {
      'is-active': _vm.tipoCobro === 'particular'
    },
    on: {
      "click": function($event) {
        _vm.tipoCobro = _vm.tipoCobro === 'particular' ? '' : 'particular';
        _vm.actualizar()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-money-bill text-gray-500"
  }), _c('span', [_vm._v("Particular")])]), _c('div', {
    staticClass: "flex flex-col flex-1 cursor-pointer justify-center items-center m-1 bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded py-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm transition duration-300 ease-in-out",
    class: {
      'is-active': _vm.tipoCobro === 'credito'
    },
    on: {
      "click": function($event) {
        _vm.tipoCobro = _vm.tipoCobro === 'credito' ? '' : 'credito';
        _vm.actualizar()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-money-check text-gray-500"
  }), _c('span', [_vm._v("Crédito")])]), _c('div', {
    staticClass: "flex flex-col flex-1 cursor-pointer justify-center items-center m-1 bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded py-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm transition duration-300 ease-in-out",
    class: {
      'is-active': _vm.tipoCobro === 'transferencia'
    },
    on: {
      "click": function($event) {
        _vm.tipoCobro = _vm.tipoCobro === 'transferencia' ? '' : 'transferencia';
        _vm.actualizar()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-money-check text-gray-500"
  }), _c('span', [_vm._v("Transferencia")])])])])])]), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    key: "tecnico",
    staticClass: "flex mb-2 p-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Técnico")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nombreTecnico),
      expression: "nombreTecnico"
    }],
    ref: "tecnico",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "placeholder": "No se han ingresado datos",
      "disabled": _vm.perfil === 'tecnico'
    },
    domProps: {
      "value": (_vm.nombreTecnico)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.showPopoverTecnico = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.showPopoverTecnico = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        _vm.showPopoverTecnico = true
      }],
      "click": function($event) {
        _vm.showPopoverTecnico = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nombreTecnico = $event.target.value
      }
    }
  }), _vm._m(3), (_vm.perfil !== 'tecnico') ? _c('span', {
    staticClass: "absolute right-0 top-0 pt-2 pr-3",
    on: {
      "click": function($event) {
        _vm.showPopoverTecnico = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-down text-gray-500"
  })]) : _vm._e(), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [(_vm.showPopoverTecnico) ? _c('u-popover', {
    on: {
      "close": function($event) {
        _vm.showPopoverTecnico = false
      }
    }
  }, [_c('tecnico-seleccionar', {
    on: {
      "selected": _vm.seleccionarTecnico,
      "close": _vm.cerrarTecnico
    }
  })], 1) : _vm._e()], 1)], 1)])]), _c('div', {
    key: "enfermera",
    staticClass: "flex mb-2 p-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Enfermera")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nombreEnfermera),
      expression: "nombreEnfermera"
    }],
    ref: "enfermera",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "placeholder": "No se han ingresado datos",
      "disabled": _vm.perfil === 'enfermera'
    },
    domProps: {
      "value": (_vm.nombreEnfermera)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.showPopoverEnfermera = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.showPopoverEnfermera = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        _vm.showPopoverEnfermera = true
      }],
      "click": function($event) {
        _vm.showPopoverEnfermera = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nombreEnfermera = $event.target.value
      }
    }
  }), _vm._m(4), (_vm.perfil !== 'enfermera') ? _c('span', {
    staticClass: "absolute right-0 top-0 pt-2 pr-3",
    on: {
      "click": function($event) {
        _vm.showPopoverEnfermera = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-down text-gray-500"
  })]) : _vm._e(), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [(_vm.showPopoverEnfermera) ? _c('u-popover', {
    on: {
      "close": function($event) {
        _vm.showPopoverEnfermera = false
      }
    }
  }, [_c('enfermera-seleccionar', {
    on: {
      "selected": _vm.seleccionarEnfermera,
      "close": _vm.cerrarEnfermera
    }
  })], 1) : _vm._e()], 1)], 1)])]), _c('div', {
    key: "fechaDesde",
    staticClass: "flex mb-2 p-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Fecha desde")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fechaDesde),
      expression: "fechaDesde"
    }],
    ref: "fechaDesde",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.fechaDesde)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fechaDesde = $event.target.value
      }
    }
  }), _vm._m(5)])])]), _c('div', {
    key: "fechaHasta",
    staticClass: "flex mb-2 p-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Fecha hasta")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fechaHasta),
      expression: "fechaHasta"
    }],
    ref: "fechaHasta",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "type": "date",
      "placeholder": "No se han ingresado datos"
    },
    domProps: {
      "value": (_vm.fechaHasta)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fechaHasta = $event.target.value
      }
    }
  }), _vm._m(6)])])])])]), _c('div', {
    key: "buttons",
    staticClass: "flex mb-2 p-2 flex-col text-xs"
  }, [_c('button', {
    staticClass: "text-primary border-primary border font-bold py-1 px-2 rounded cursor-pointer",
    on: {
      "click": _vm.fetch
    }
  }, [_vm._v("Refrescar")]), _c('button', {
    staticClass: "mt-1 bg-primary text-white font-bold py-1 px-2 rounded cursor-pointer",
    attrs: {
      "disabled": _vm.isLoadingExcel
    },
    on: {
      "click": _vm.downloadExcel
    }
  }, [_vm._v("Exportar excel")])])]), _c('table', {
    staticClass: "w-full"
  }, [_c('thead', {
    staticClass: "sticky top-0"
  }, [_c('tr', {
    staticClass: "sticky top-0"
  }, [_c('th', {
    staticClass: "w-10 py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('fecha')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Fecha")]), (_vm.sortByName === 'fecha') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "w-10 py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('hora')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Hora")]), (_vm.sortByName === 'hora') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('nombreDoctor')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Doctor")]), (_vm.sortByName === 'nombreDoctor') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('descripcionClinica')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Clínica")]), (_vm.sortByName === 'descripcionClinica') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('descripcionTipoCirugia')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Tipo Cirugía")]), (_vm.sortByName === 'descripcionTipoCirugia') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('nombreTecnico')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Técnico")]), (_vm.sortByName === 'nombreTecnico') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('nombreEnfermera')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Enfermera")]), (_vm.sortByName === 'nombreEnfermera') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('tipoCobro')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Tipo cobro")]), (_vm.sortByName === 'tipoCobro') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('montoCobrado')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Monto Cobrado")]), (_vm.sortByName === 'montoCobrado') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('nombrePaciente')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Nombre Paciente")]), (_vm.sortByName === 'nombrePaciente') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('clipsUtilizados')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Clips Utilizados")]), (_vm.sortByName === 'clipsUtilizados') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('codigoMarcaGrapa')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Marca de grapas")]), (_vm.sortByName === 'codigoMarcaGrapa') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('grapasUtilizadas')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Grapas Utilizadas")]), (_vm.sortByName === 'grapasUtilizadas') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('numeroCaja')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Número de caja")]), (_vm.sortByName === 'numeroCaja') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _vm._m(7), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('fechaCreacion')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Fecha Creación")]), (_vm.sortByName === 'fechaCreacion') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('fechaModificacion')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Fecha Modificación")]), (_vm.sortByName === 'fechaModificacion') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('creadoPor')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Creado por")]), (_vm.sortByName === 'creadoPor') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])])])]), _c("transition-group", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lista.length !== 0),
      expression: "lista.length !== 0"
    }, {
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    tag: "tbody",
    staticClass: "text-xs",
    attrs: {
      "name": "slide-up",
      "infinite-scroll-disabled": "disabledScrollExecute",
      "infinite-scroll-distance": "2"
    }
  }, _vm._l((_vm.lista), function(item, index) {
    return _c('tr', {
      key: index + 1,
      ref: "task",
      refInFor: true,
      staticClass: "hover:bg-gray-100",
      on: {
        "dblclick": function($event) {
          return _vm.irACirugia(item._id)
        },
        "contextmenu": function($event) {
          $event.preventDefault();
          return _vm.openMenu(item, index)
        }
      }
    }, [_c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v(_vm._s(item.fechaString))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v(_vm._s(item.hora))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v(_vm._s(item.nombreDoctor))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v(_vm._s(item.descripcionClinica))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v(_vm._s(item.descripcionTipoCirugia))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v(_vm._s(item.nombreTecnico))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v(_vm._s(item.nombreEnfermera))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v(_vm._s(item.tipoCobro))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v("S/" + _vm._s(_vm._f("twoDecimals")(item.montoCobrado)))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v(_vm._s(item.nombrePaciente))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light text-center"
    }, [_vm._v(_vm._s(item.clipsUtilizados))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [(item.descripcionMarcaGrapa) ? _c('span', [_vm._v(_vm._s(item.descripcionMarcaGrapa))]) : _vm._e()]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light text-center"
    }, [(!item.grapasMoradas && !item.grapasNegras && !item.grapasDoradas) ? _c('span', [_vm._v(_vm._s(item.grapasUtilizadas))]) : _vm._e(), (item.grapasMoradas) ? _c('span', {
      staticClass: "p-1 ml-1 rounded-full bg-purple-500 text-white"
    }, [_vm._v(_vm._s(item.grapasMoradas))]) : _vm._e(), (item.grapasNegras) ? _c('span', {
      staticClass: "p-1 ml-1 rounded-full bg-black text-white"
    }, [_vm._v(_vm._s(item.grapasNegras))]) : _vm._e(), (item.grapasDoradas) ? _c('span', {
      staticClass: "p-1 ml-1 rounded-full bg-yellow-500"
    }, [_vm._v(_vm._s(item.grapasDoradas))]) : _vm._e()]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light text-center"
    }, [_vm._v(_vm._s(item.numeroCaja))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v(_vm._s(item.comentario))]), _c('td', {
      staticClass: "text-center py-0 px-2 border-b border-grey-light text-gray-600"
    }, [_c('div', {
      staticClass: "flex flex-col"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("formatDateDay")(item.fechaCreacion)))]), _c('span', {
      staticClass: "text-xxs"
    }, [_vm._v(_vm._s(_vm._f("formatDateHour")(item.fechaCreacion)))])])]), _c('td', {
      staticClass: "text-center py-0 px-2 border-b border-grey-light text-gray-600"
    }, [_c('div', {
      staticClass: "flex flex-col"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("formatDateDay")(item.fechaModificacion)))]), _c('span', {
      staticClass: "text-xxs"
    }, [_vm._v(_vm._s(_vm._f("formatDateHour")(item.fechaModificacion)))])])]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v(_vm._s(item.creadoPor))])])
  }), 0)], 1)]), (_vm.lista.length === 0 && !_vm.isLoading) ? _c('div', {
    staticClass: "m-2 mt-3 text-xs text-left text-blue-600 bg-blue-200 border border-blue-400 flex items-center p-3 rounded-sm"
  }, [_vm._v("No existe ninguna cirugía registrada.")]) : _vm._e(), (_vm.isLoading) ? _c('div', {
    staticClass: "is-loading flex items-center justify-center text-primary text-xl"
  }, [_c('i', {
    staticClass: "fas fa-spinner fa-spin"
  })]) : _vm._e(), _c('div', {
    staticClass: "fixed bottom-0 right-0 padding-floating-button"
  }, [_c('div', {
    staticClass: "flex justify-center items-center p-0 w-10 h-10 bg-primary rounded-full mouse shadow text-white",
    on: {
      "click": _vm.nuevaCirugia
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-user-md text-gray-500"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-hospital text-gray-500"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-procedures text-gray-500"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-user-cog text-gray-500"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-user-nurse text-gray-500"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-calendar text-gray-500"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-calendar text-gray-500"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Comentario")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f8cbcbc","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/v_cirugia_list.vue
// module id = 233
// module chunks = 1